import React, { useState } from 'react'
import { Route, Switch } from 'react-router-dom'
import { Breadcrumb, Container, ListNav } from '../../components'
import { useInternationalization } from '../../features/i18n'
import { useViewport } from '../../utils'
import { DashboardEventForm } from '../dashboard-events-form'
import { FormVisibility, PageHeaderDesktop } from './components'
import { PageContent } from './components/page-content.v1'

const Form = ({isEdit, ...props}) => {
  const { translate } = useInternationalization()
  const tabs = [
    'Field Event',
    translate('DASHBOARD', 'visibility_settings')
  ]
  const [activeTab, setActiveTab] = useState(tabs[0])
  const { isDesktop } = useViewport()

  const routes = [
    {
      name: translate('NAVIGATION', 'dashboard'),
      route: '/dashboard'
    },
    {
      name: translate('EVENT', 'our'),
      route: '/dashboard/events'
    },
  ]

  return (
    isDesktop ? <>
      <div>
        <Breadcrumb routes={routes}/>
        <h1 className="text-4xl font-bold font-primary">
          { isEdit ? `Edit ${translate('EVENT', 'singular')}` : translate('EVENT', 'create') }
        </h1>
        <hr className="mt-5 mb-8"/>
        {
          isEdit &&
          <ListNav tabs={tabs} activeTab={activeTab} onChange={(e) => setActiveTab(e)}/>
        }
      </div>
      {
        activeTab === tabs[0] &&
        <DashboardEventForm {...props}/>
      }
      {
        activeTab === tabs[1] &&
        <FormVisibility />
      }
    </> : <>
      {
        isEdit &&
        <ListNav tabs={tabs} activeTab={activeTab} onChange={(e) => setActiveTab(e)}/>
      }
      <Container>
        {
          activeTab === tabs[0] &&
          <DashboardEventForm {...props}/>
        }
        {
          activeTab === tabs[1] &&
          <FormVisibility />
        }
      </Container>
    </>
  )
}

const DashboardEvents = () => {
  const { isDesktop } = useViewport()

  return (<>
    <Switch>
      <Route
        path="/dashboard/events/update/:id"
        render={(props) => <Form {...props} isEdit/>}
      >
      </Route>
      <Route
        path="/dashboard/events/create"
        render={(props) => <Form {...props}/>}
        exact
      >
      </Route>
      <Route path="/dashboard/events" exact={true}>
        { isDesktop && <PageHeaderDesktop /> }
        { isDesktop && <PageContent /> }
        { !isDesktop &&
          <Container className="py-5">
            <PageContent />
          </Container>
        }
      </Route>
    </Switch>
  </>)
}

export { DashboardEvents }
